import { Diagnosis, DiagnosisCategory, MCHistoryItem } from '../types/dispense';

// ============================================================
// ACUTE DIAGNOSES - Matching CheckLine's FormDiagnosisSelector
// ============================================================

// Common / Quick-Select acute diagnoses (main buttons in CheckLine)
export const COMMON_ACUTE_DIAGNOSES: Diagnosis[] = [
  { code: 'J069', name: 'URTI / ARI' },
  { code: 'N390', name: 'UTI' },
  { code: 'R074', name: 'Chest Pain' },
  { code: 'J209', name: 'Bronchitis' },
  { code: 'K219', name: 'GERD' },
  { code: 'R42', name: 'Giddiness' },
  { code: 'M1399', name: 'Arthritis' },
  { code: 'K30', name: 'Dyspepsia' },
  { code: 'R51', name: 'Headache' },
  { code: 'M5499', name: 'Back Pain' },
  { code: 'H109', name: 'Conjunctivitis' },
  { code: 'K590', name: 'Constipation' },
  { code: 'H612', name: 'Impacted Cerumen' },
  { code: 'L089', name: 'Skin Infection' },
  { code: 'A099', name: 'Gastroenteritis' },
  { code: 'R104', name: 'Abdominal Pain' },
  { code: 'H001', name: 'Chalazion' },
  { code: 'L209', name: 'Eczema / AD' },
  { code: 'K297', name: 'Gastritis' },
  { code: 'L509', name: 'Urticaria' },
  { code: 'M7919', name: 'Myalgia' },
  { code: 'N946', name: 'Dysmenorrhea' },
];

// All acute diagnoses organized by category (matching CheckLine's AccessibleName groups)
export const ACUTE_CATEGORIES: DiagnosisCategory[] = [
  {
    label: 'Respiratory',
    items: [
      { code: 'J069', name: 'URTI / ARI' },
      { code: 'J209', name: 'Bronchitis' },
      { code: 'J010', name: 'Sinusitis' },
      { code: 'J189', name: 'Pneumonia' },
      { code: 'J989', name: 'Other Resp Disorders' },
    ]
  },
  {
    label: 'Gastrointestinal',
    items: [
      { code: 'K219', name: 'GERD' },
      { code: 'K30', name: 'Dyspepsia' },
      { code: 'K297', name: 'Gastritis' },
      { code: 'A099', name: 'Gastroenteritis' },
      { code: 'K590', name: 'Constipation' },
      { code: 'R104', name: 'Abdominal Pain' },
      { code: 'K469', name: 'Hernia' },
      { code: 'K580', name: 'IBS' },
      { code: 'K639', name: 'Other GIT Problems' },
      { code: 'K829', name: 'Gallbladder Disease' },
    ]
  },
  {
    label: 'Dermatology / Skin',
    items: [
      { code: 'L209', name: 'Eczema / AD' },
      { code: 'L089', name: 'Skin Infection' },
      { code: 'L509', name: 'Urticaria' },
      { code: 'L309', name: 'Dermatitis, NOS' },
      { code: 'L609', name: 'Nail Disease' },
      { code: 'L709', name: 'Acne Vulgaris' },
      { code: 'L299', name: 'Pruritus' },
      { code: 'L989', name: 'Other Skin Disorders' },
      { code: 'B07', name: 'Viral Warts' },
      { code: 'B369', name: 'Tinea' },
    ]
  },
  {
    label: 'Eye / Ear',
    items: [
      { code: 'H109', name: 'Conjunctivitis' },
      { code: 'H001', name: 'Chalazion' },
      { code: 'H612', name: 'Impacted Cerumen' },
      { code: 'H269', name: 'Cataract' },
      { code: 'H609', name: 'Otitis Externa' },
      { code: 'H669', name: 'Otitis Media' },
      { code: 'H939', name: 'Other Ear Disorders' },
      { code: 'H579', name: 'Other Eye Disorders' },
    ]
  },
  {
    label: 'Oral / Dental',
    items: [
      { code: 'K089', name: 'Dental Disorders' },
      { code: 'K119', name: 'Salivary Gland' },
      { code: 'K137', name: 'Oral Mucosa' },
    ]
  },
  {
    label: 'Musculoskeletal',
    items: [
      { code: 'M5499', name: 'Back Pain' },
      { code: 'M1399', name: 'Arthritis' },
      { code: 'M7919', name: 'Myalgia' },
      { code: 'M722', name: 'Plantar Fasciitis' },
      { code: 'M6799', name: 'Tendon/Synovitis/Bursa' },
    ]
  },
  {
    label: 'Cardiovascular',
    items: [
      { code: 'R074', name: 'Chest Pain' },
      { code: 'I849', name: 'Piles / Hemorrhoids' },
      { code: 'I839', name: 'Varicose Veins' },
      { code: 'I499', name: 'Arrhythmia' },
      { code: 'I519', name: 'Heart Disease' },
      { code: 'I99', name: 'Other CVS' },
      { code: 'R030', name: 'Elevated BP w/o HTN' },
    ]
  },
  {
    label: 'Urinary',
    items: [
      { code: 'N390', name: 'UTI' },
      { code: 'N209', name: 'Urinary Calculus' },
      { code: 'N399', name: 'Other Urinary' },
      { code: 'R80', name: 'Proteinuria' },
      { code: 'R31', name: 'Hematuria' },
    ]
  },
  {
    label: 'Sexual / Reproductive',
    items: [
      { code: 'N946', name: 'Dysmenorrhea' },
      { code: 'N949', name: 'Other Gynae' },
      { code: 'N509', name: 'Male Genital Issues' },
      { code: 'F529', name: 'Sexual Dysfunction' },
      { code: 'N649', name: 'Other Breast' },
      { code: 'N63', name: 'Breast Lump' },
      { code: 'N920', name: 'Menorrhagia' },
      { code: 'O269', name: 'Pregnancy-Related' },
    ]
  },
  {
    label: 'Hemato / Endocrine',
    items: [
      { code: 'E039', name: 'Hypothyroidism' },
      { code: 'E059', name: 'Hyperthyroidism' },
      { code: 'D649', name: 'Anemia' },
      { code: 'E162', name: 'Hypoglycemia' },
      { code: 'D369', name: 'Benign Neoplasm' },
      { code: 'C80', name: 'Malignant Neoplasm' },
      { code: 'E669', name: 'Obesity' },
    ]
  },
  {
    label: 'Neurology',
    items: [
      { code: 'R51', name: 'Headache' },
      { code: 'R42', name: 'Giddiness' },
      { code: 'G629', name: 'Polyneuropathy' },
      { code: 'G589', name: 'Mononeuropathy' },
      { code: 'G470', name: 'Insomnia' },
    ]
  },
  {
    label: 'Infectious Diseases',
    items: [
      { code: 'B99', name: 'Other Infectious Dz' },
      { code: 'B029', name: 'Zoster / Shingles' },
      { code: 'B019', name: 'Chickenpox' },
      { code: 'B084', name: 'HFMD' },
      { code: 'A90', name: 'Dengue Fever' },
      { code: 'Z21', name: 'HIV' },
      { code: 'Z2251', name: 'Hep B Carrier' },
      { code: 'B199', name: 'Hepatitis, Viral' },
    ]
  },
  {
    label: 'Trauma / Injury',
    items: [
      { code: 'T149', name: 'Injury - Other' },
      { code: 'T009', name: 'Injury - Abrasion' },
      { code: 'T019', name: 'Injury - Open Wound' },
      { code: 'T1405', name: 'Injury - Contusion' },
      { code: 'T1420', name: 'Injury - Fracture' },
      { code: 'T300', name: 'Injury - Burn' },
      { code: 'S099', name: 'Injury - Head' },
      { code: 'T149', name: 'Injury - Sprain/Strain' },
      { code: 'T1404', name: 'Injury - FB Skin' },
      { code: 'T189', name: 'Injury - FB Throat' },
      { code: 'T16', name: 'Injury - FB Ear' },
      { code: 'T159', name: 'Injury - FB Eye' },
      { code: 'T171', name: 'Injury - FB Nose' },
    ]
  },
  {
    label: 'Miscellaneous',
    items: [
      { code: 'Z099A', name: 'Health Screening' },
      { code: 'Z099B', name: 'Medical Examination' },
      { code: 'Z099C', name: 'Admin Only' },
      { code: 'Z099', name: 'Follow-Up Review' },
      { code: 'Z269', name: 'Immunization' },
      { code: 'Z001', name: 'Child Dev Screen' },
      { code: 'R509', name: 'Fever' },
      { code: 'T784', name: 'Allergy' },
      { code: 'R040', name: 'Epistaxis' },
      { code: 'P599', name: 'Neonatal Jaundice' },
    ]
  },
];

// Flat list of ALL acute diagnoses (for search & backward compat)
export const ALL_ACUTE_DIAGNOSES: Diagnosis[] = ACUTE_CATEGORIES.flatMap(cat => cat.items)
  .filter((d, i, arr) => arr.findIndex(x => x.code === d.code) === i); // dedupe

// Keep backward compat reference
export const ACUTE_DIAGNOSES = ALL_ACUTE_DIAGNOSES;

// ============================================================
// CHRONIC DIAGNOSES - Matching CheckLine's FormDiagnosisSelector
// ============================================================
export const CHRONIC_DIAGNOSES: Diagnosis[] = [
  { code: 'I10', name: 'Hypertension' },
  { code: 'E11', name: 'Type 2 Diabetes Mellitus' },
  { code: 'E10', name: 'Type 1 Diabetes Mellitus' },
  { code: 'E09', name: 'Pre-Diabetes' },
  { code: 'E785', name: 'Hyperlipidemia' },
  { code: 'J459', name: 'Asthma' },
  { code: 'J449', name: 'COPD' },
  { code: 'N189', name: 'Chronic Kidney Disease' },
  { code: 'N40', name: 'Benign Prostatic Hyperplasia' },
  { code: 'F33', name: 'Depression' },
  { code: 'F319', name: 'Bipolar Disorder' },
  { code: 'F209', name: 'Schizophrenia' },
  { code: 'F419', name: 'Anxiety' },
  { code: 'I64', name: 'Stroke / CVA / TIA' },
  { code: 'F03', name: 'Dementia' },
  { code: 'G4090', name: 'Epilepsy' },
  { code: 'G20', name: "Parkinson's Disease" },
  { code: 'M179', name: 'Osteoarthritis (Knee)' },
  { code: 'M169', name: 'Osteoarthritis (Hip)' },
  { code: 'M1999', name: 'Osteoarthritis (Other)' },
  { code: 'M0599', name: 'Rheumatoid Arthritis (Sero +)' },
  { code: 'M0609', name: 'Rheumatoid Arthritis (Other)' },
  { code: 'M0809', name: 'Juvenile Rheumatoid Arthritis' },
  { code: 'M8199', name: 'Osteoporosis (Frx / No Frx)' },
  { code: 'L409', name: 'Psoriasis' },
  { code: 'I24', name: 'Acute IHD' },
  { code: 'I25', name: 'Chronic IHD' },
  { code: 'M10', name: 'Gout' },
  { code: 'B181', name: 'Chronic Hepatitis B' },
  { code: 'J304', name: 'Allergic Rhinitis' },
];

// MC History dummy data (no backend endpoint yet)
export const DUMMY_MC_HISTORY: MCHistoryItem[] = [
  { id: 1, date: '15 Jan 2026', store: 'Ang Mo Kio', doctor: 'Dr. Lim Mei Ling', fromDate: '15 Jan 2026', toDate: '17 Jan 2026', days: 2, diagnosis: 'URTI, Fever' },
  { id: 2, date: '18 Dec 2025', store: 'Ang Mo Kio', doctor: 'Dr. Lim Mei Ling', fromDate: '18 Dec 2025', toDate: '20 Dec 2025', days: 2, diagnosis: 'Gastritis' },
  { id: 3, date: '05 Dec 2025', store: 'Clementi', doctor: 'Dr. Wong Ah Kow', fromDate: '05 Dec 2025', toDate: '06 Dec 2025', days: 1, diagnosis: 'URTI' },
  { id: 4, date: '20 Nov 2025', store: 'Ang Mo Kio', doctor: 'Dr. Lim Mei Ling', fromDate: '20 Nov 2025', toDate: '22 Nov 2025', days: 2, diagnosis: 'Fever, Headache' },
];

// Page tab labels
export const PAGE_LABELS = ['Case Note History', 'Current Visit', 'Dispense History', 'Memos', 'MC History'];
export const TOTAL_PAGES = 5;
